import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#050505] mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-cyan-400 flex items-center justify-center">
              <Sparkles className="w-4 h-4" />
            </div>
            <span className="font-display font-bold">VisionAI Studio</span>
          </div>
          <p className="text-sm text-white/50 max-w-xs">Générez des vidéos IA de qualité cinéma en quelques secondes.</p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Produit</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/pricing" className="text-white/60 hover:text-white">Tarifs</Link></li>
            <li><Link to="/blog" className="text-white/60 hover:text-white">Blog</Link></li>
            <li><Link to="/faq" className="text-white/60 hover:text-white">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Entreprise</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="text-white/60 hover:text-white">Contact</Link></li>
            <li><Link to="/terms" className="text-white/60 hover:text-white">Conditions</Link></li>
            <li><Link to="/privacy" className="text-white/60 hover:text-white">Confidentialité</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Compte</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/login" className="text-white/60 hover:text-white">Connexion</Link></li>
            <li><Link to="/register" className="text-white/60 hover:text-white">Inscription</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-white/40">
        © 2026 VisionAI Studio. Tous droits réservés.
      </div>
    </footer>
  );
}
